



































import { defineComponent } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import InputText from '@/features/ui/inputs/InputText.global.vue';
import { Register } from '@/features/core/store/page-modules/modbus-edit-registers/modbus-edit-register.module';
import _debounce from 'lodash/debounce';
import { formatModbusMetricOldValue, formatModbusMetricValue } from '@/features/core/util/metric-formatters';

export default defineComponent<any, Record<string, unknown>, any, any, any>({
  components: { InputText },
  data() {
    return {
      loading: false,
      allRegisters: [] as Register[],
    };
  },
  computed: {
    ...mapGetters(['activeClusterName', 'activeHeatingSystemClusterRegisters', 'activeHeatingSystemMetrics']),
    filteredRegister(): Register[] {
      if (!this.activeHeatingSystemClusterRegisters) return [];

      return this.activeHeatingSystemClusterRegisters.map((register: Register) => ({
        ...register,
      }));
    },
  },
  watch: {},
  methods: {
    saveAllRegisters(register: Register) {
      if (!register.value) {
        register.value = null;
      } else {
        register.oldValue = this.formatValue(
          this.activeHeatingSystemMetrics[register.registerName],
          register.registerName,
          true,
        ).trim();
      }
      this.saveRegister(register, this);
    },
    formatValue(value: string | number, name: string, isOldValue = false): string {
      if (!value) {
        return 'N/A';
      }
      return isOldValue ? formatModbusMetricOldValue(value) : formatModbusMetricValue(name ?? '', value);
    },
    saveRegister: _debounce(function (val: Register, that: any) {
      that.$store.dispatch('saveRegisterValue', val);
    }, 500),
  },
});
